var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M39.524 41.858v-5.236h-2.615v5.236z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M36.91 36.622h2.614v5.236h-2.615v2.618h-2.614v2.617H26.45v2.618h10.458v-2.618h2.615v-2.617h2.615V34.004h-2.615v-2.617h-2.615z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M36.91 41.858h-2.615v2.618h2.614z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#055590",
    d: "M36.91 39.24h-2.615v2.618h2.614z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M36.91 31.387v-2.618h-7.845v2.618z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M34.295 47.093v-2.617H26.45v2.617z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D5D8",
    d: "M34.295 36.622v-2.618h-5.23v2.618zM29.065 36.622h-2.614v2.618h2.614z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0971AA",
    d: "M29.065 34.004h-2.614v2.618h2.614z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M23.836 44.476h-2.588v2.617h5.203v-2.617z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#055590",
    d: "M26.45 44.476h7.845v-2.618H23.836v2.618z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M23.863 41.858h-2.615v2.618h2.615z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M21.221 41.858h-2.587v2.618h2.587z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M21.221 39.24h-2.587v2.618h2.587zM21.248 7.853h-2.614v7.854h2.614z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M18.634 39.24h-2.615v2.618h2.615z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M18.634 36.622h-2.615v2.618h2.615z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M16.019 15.707h-2.615V26.15h2.615v2.618h2.614v2.618h2.615v2.617h2.588v2.618h2.615v-2.618h2.614v-2.617h-5.23v-2.618h-2.587V26.15h-2.615v-2.59H16.02v-5.236h5.23v-2.618h-5.23"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#055590",
    d: "M18.634 7.853V5.236h-2.615v10.47h2.615z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M16.019 36.622h-2.615v2.618h2.615z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M16.019 34.004h-2.615v2.618h2.615z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M13.404 34.004h-2.615v2.618h2.615z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M13.404 31.387H10.79v2.617h2.615z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D5D8",
    d: "M13.404 7.853V5.236h-5.23v2.617z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M16.019 2.618v2.618h2.615v2.617h2.614v7.854h2.588V5.236h-2.588V2.618h-2.614V0H8.174v2.618zM10.79 31.387H8.174v2.617h2.614z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M10.79 26.151H8.175v5.236h2.614z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0971AA",
    d: "M13.404 5.236v2.617h-5.23v2.618H5.56v10.471h2.615v5.209h2.614v5.236h2.615v2.617h2.615v2.618h2.615v2.618h2.614v2.618h13.047V39.24h2.614v-7.853h-7.844v2.617h5.23v2.618h-5.23v2.618h-2.614v-2.618h-2.615v-2.618h-2.588v-2.617h-2.615v-2.618H16.02V26.15h-2.615V15.707h2.615V2.618H8.175v2.618z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M8.175 26.151H5.56v5.236h2.615z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M8.175 20.942H5.56v5.209h2.615z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D5D8",
    d: "M8.175 7.853H5.56v2.618h2.615z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0971AA",
    d: "M8.175 5.236H5.56v2.617h2.615z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M8.175 2.618H5.56v2.618h2.615zM5.56 20.942H2.946v5.209H5.56z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#184274",
    d: "M5.56 18.325H2.946v2.617H5.56z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#055590",
    d: "M2.946 18.325H5.56V7.853H2.946z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2135",
    d: "M5.56 5.236H2.946v2.617H5.56zM2.946 18.325V7.853H.358v13.09h2.588z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#092835",
    d: "M35.858 0h3.094v3.094h-3.094zM29.67 6.187h3.094v3.094H29.67zM29.67 9.281h3.094v3.094H29.67zM32.764 12.375h3.094v3.094h-3.094zM32.764 15.469h3.094v3.094h-3.094zM29.67 18.562h3.094v3.094H29.67zM38.951 3.094h3.094v3.094h-3.094zM42.045 6.187h3.094v3.094h-3.094zM42.045 9.281h3.094v3.094h-3.094zM42.045 12.375h3.094v3.094h-3.094zM42.045 15.469h3.094v3.094h-3.094zM38.951 18.562h3.094v3.094h-3.094z"
  })));
};
export default SvgPhone;